export enum FilePickerMode {
  UPLOAD = 'upload',
  RECORD = 'recorder',
}
